// /chat/$sessionId — the existing-chat URL. A pure MATCHER now: the chat surface
// is rendered ONCE by the shared parent (routes/chat-shell.tsx), which reads the
// session id off the location and owns the single GenUIChat instance shared with
// '/'. A sibling route could not keep that instance alive across the mid-turn
// URL swap — see chat-shell.tsx's header. Registered from routes/core.tsx.
//
// TODO(G1 resume de-dupe — binding, see FRONTEND_SPA_DESIGN.md's "G1 PROBE
// RESULTS" addendum, finding #2): after a resume reattach (GET
// /api/chat/:sessionId/resume -> 200), the reattached stream and the
// persisted transcript briefly double-render the in-flight turn. The probe
// observed this; the real port needs de-dupe by message id (and the eval in
// design doc §7.3 "Mid-stream refresh resume" must assert no duplicate
// message ids after settle) before this route is considered parity-complete.
import { createRoute } from '@tanstack/react-router';
import { chatShellRoute } from './chat-shell';

export const chatSessionRoute = createRoute({
  getParentRoute: () => chatShellRoute,
  path: '/chat/$sessionId',
  component: () => null,
});
